/* ------------------------------------------- */
/*   Queries for set sponsor
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import { postRESTQuery } from 'AppSrc/core/queries/axios-queries';

const setCrqSponsor = ({
  email, // azure AD email of sponsor
  network,
  crqId,
}) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.sponsor.set}`;
  const params = {
    network,
    crq_id: crqId,
    id: email,
  };
  return postRESTQuery(endpoint, params)
    .then((response) => response.data);
};

export { setCrqSponsor };
